import React from 'react';
import ReactDOM from 'react-dom';
import LoggedInPage from '../../views/core/LoggedInPage';
import { FormGroup, Label, Input } from 'reactstrap';
import AdminLayout from './AdminLayout';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import HmAjax from '../../util/HmAjax';
import CoreAjax from '../../util/CoreAjax';
// import SearchLayout from './SearchLayout';
import AdminModal from './AdminModal';
import $ from 'jquery';
import Loader from 'react-loader-spinner';
import HmEventRegistry from '../../model/HmEventRegistry';

export default class PendingRegTable extends LoggedInPage {

    constructor(props){
        super(props)
        this.state={
          dataLoaded:false,
          dropdownOpen: false,
          tableData:null,
          data:["All","None"],
          modalShow:false,
          tick:false,
          allowtoShow:false,
          type:"",
          pending: null,
          registered: 0,
          countLoaded: false,
          schoolsDataList:null,
          nouseravailable:false,
          RegistrationOpen:false
      }

      this.toggle = this.toggle.bind(this);
      this.createSelectItems = this.createSelectItems.bind(this);
      this.customDropdown = this.customDropdown.bind(this);
      this.checkAllfn = this.checkAllfn.bind(this);
      this.dropdownCheckAllfn = this.dropdownCheckAllfn.bind(this);
      //this.type= '';
      this.getuserList = this.getuserList.bind(this);
      this.createStudent = this.createStudent.bind(this);
      this.editStudent = this.editStudent.bind(this);
      this.removeStudent = this.removeStudent.bind(this);
      this.hideAdminModal = this.hideAdminModal.bind(this);
      this.editCheckBox = this.editCheckBox.bind(this);
      this.registerFn = this.registerFn.bind(this);
      this.removeUserData = this.removeUserData.bind(this);

      this.userList=[];
      this.userData=null;
      this.duplicateEntryAllowed = (window.contest_reg_duplicates && window.contest_reg_duplicates["allowed"]) ? window.contest_reg_duplicates["allowed"] : false;
      this.duplicateLoginIds = new Set();
      this.duplicateLoginIdAction = (window.contest_reg_duplicates && window.contest_reg_duplicates["action"]) ? window.contest_reg_duplicates["action"].toLowerCase() : null;
      this.selectAllData = this.selectAllData.bind(this);
      this.getCount = this.getCount.bind(this);
      this.tableStatus="pending";
      //this.jsonLoad =  false;
    }

    componentDidMount(){
        let RegistrationOpen = this.props.RegistrationOpen || false;
        this.loadJson();
        this.getContestLevelName();
        this.setState({RegistrationOpen:RegistrationOpen});
        //console.log("RegistrationOpen componentDidMount Pen",RegistrationOpen);
        HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
    }

    getContestLevelName(){
        let me=this;

        var callBackSuccess=function(response){
            //console.log("getContestLevelName ",response);
            if(response!==null){
                if(response.status=="success"){
                    //me.selectedSchoolOption = response.schoolsList
                    //me.setState({selectedSchoolOption:response.schoolsList})
                    if(response.levelSecInfo){
                        me.setState({schoolsDataList:response})
                        //me.populateSchoolLevelDropdown(response.levelSecInfo);
                    }
                }
            }
        }

        var callBackFailure=function(response){
            //console.log("response school failure",response);
        }

         new HmAjax(this.getUrlFor("CONTEST_TIC_LEV_AND_SEC").replace("{#contestId}",this.getContestHost())).get(callBackSuccess, callBackFailure);
        
    }

    getCount(forceLoad=false){
        let me = this;
        if(typeof this.props.getCount === "function"){
            this.props.getCount(forceLoad, (resp) => {
                //console.log("getCount ",(resp && !isNaN(resp.pending)) ? resp.pending : 0);
                me.setState({countLoaded: true, registered: (resp && !isNaN(resp.registered)) ? resp.registered : 0, pending: (resp && !isNaN(resp.pending)) ? resp.pending : 0 });
            });
        }
    }

    duplicateItem = function (srcdata,key, value) {
        if (value == undefined)
            return false;

        for (var i in srcdata) {
            if (srcdata[i][key] == value) {
               return true;
           }
       }
       return false;
   };

   removeItem = function (srcdata,key, value) {
    if (value == undefined)
        return;
    for (var i in srcdata) {
        if (srcdata[i][key] == value) {
            srcdata.splice(i, 1);
        }
    }
};


addUserData(userdata){
    let userData = this.userDataForRegn(userdata);
    //console.log("userData",userData);
    let userRefId = userData.userRefId;
    //console.log("userRefId",userRefId);
    let arr = this.userList;
    let me=this;
    if(me.duplicateItem(me.userList,"userRefId",userRefId)){
        me.removeItem(me.userList,"userRefId",userRefId)
    }else{
        me.userList.push(userData)
    }
    this.refreshUI();
    return this.userList; 
}

refreshUI(){
    if(this.userList.length>0 && !this.state.allowtoShow){
        this.setState({allowtoShow:true});
    }else if(this.userList.length<=0 && this.state.allowtoShow){
        $("#checkAll").prop("checked",false);
        this.setState({allowtoShow:false});
    }

    if(this.state.tableData!==null && this.userList.length === this.state.tableData.length){
        $("#checkAll").prop("checked",true);
    }else{
        $("#checkAll").prop("checked",false);
    }
}

userDataForRegn(userData){
    let userDataList ={
        "userRefId":userData.userRefId,
        "loginId":userData.loginId,
        "userId":userData.userId
    }
    return userDataList;
}



registerFn(e){
    let me=this;
    //console.log("typeof userlist",me.userList);
    if(me.userList.length>0){
        

    var buttons = [
        {
            label: me.rb("alert.ok"),
            handler: () => {
                me.registerStudent(me.userList)
             }
        },
        {
            label: me.rb("alert.cancel"),
            handler: () => { 
                }
        }
    ]

    this.showAlert(me.rb("contest.register.alerttitle"),me.rb("contest.register.alertdesc"),buttons);
    }
}

registerStudent(userList){
    var formObj = JSON.stringify({ "userList":Array.from(userList)||[]});
    //console.log("formObj ",typeof formObj);
    var me = this;

    var success = function(response){
        //console.log("registerStudent ",response);
        if(response && response.update_status==="success"){
            let existingUsers = (response.existingUsers) ? JSON.parse(response.existingUsers) : null;
            me.loadJson(JSON.parse(existingUsers));
            me.getCount(true);
            if(typeof me.props.switchRegTab==="function"){
                me.props.switchRegTab();
            }
            if(!me.getAttribute("contesthomevisited")){
                try{
                    me.setAttribute("contesthomevisited",true);	
                }catch(e){}
              }
            }
        } 

        var failure = function(err){

        }
        new HmAjax(this.getUrlFor("CONTEST_STUD_REG").replace("{#contestId}",this.getSelectedContestGroup()),formObj).mask().post(success, failure);
    }

    isValidContest(contestGrpId=null){
        if(!contestGrpId){
            contestGrpId = localStorage.getItem("contestType");
        }

        if(contestGrpId){
            return window.all_contests.includes(contestGrpId);
        }

        return false;           
    }

    getSelectedContestGroup(){
        let contestGrpParam = (this.props.match && this.props.match.params && this.props.match.params.contestGrpId) ? this.props.match.params.contestGrpId : localStorage.getItem("contestType");
        
        if(contestGrpParam && this.isValidContest(contestGrpParam)){
            localStorage.setItem("contestType",contestGrpParam);
        }else{            
            localStorage.setItem("contestType",window.default_contest);
        }

        return localStorage.getItem("contestType");
    }

    createStudent(){
        if(this.state.RegistrationOpen){
            this.userData=null;
            this.setState({type:"create",modalShow:true})
        }
    }

    editStudent(userObj){
        if(this.state.RegistrationOpen){
            this.userData=userObj;
            if(this.userList.length<2){
                this.setState({type:"edit",modalShow:true})
            }
            else{
                this.showAlert("Error","You must select only one user.")
            }
        }
    }

    removeUserData(userList){
       // console.log("Admin removed");
       var me = this;
        var formObj = JSON.stringify({ "userList":Array.from(userList)||[]});

        let postParams = {
            "userList":Array.from(userList)||[],
            "userStatus" : [me.tableStatus]
        }
       // console.log("formObj ",typeof formObj);
       

        var success = function(response){
            //console.log("removeUserData ",response);
            if(response && response.deleteStatus==="success"){
                let existingUsers = (response.existingUsers) ? JSON.parse(response.existingUsers) : null;
                me.loadJson(JSON.parse(existingUsers));
                me.getCount(true);
                }else{

                }
        } 

        var failure = function(err){

        }
        if(this.state.RegistrationOpen){
            new HmAjax(this.getUrlFor("CONTEST_REMOVE_STUD_FRM_PEND_REG").replace("{#contestId}",this.getSelectedContestGroup()),postParams).mask().post(success, failure);
        } 
    }

    removeStudent(){
        //console.log("Admin delete");
        //this.type="delete";
        let me=this;
        let RegistrationOpen = this.state.RegistrationOpen;
        if(RegistrationOpen && me.userList.length>0){
            var buttons = [
                {
                    label: me.rb("alert.ok"),
                    handler: () => { me.removeUserData(me.userList) }
                },
                {
                    label: me.rb("alert.cancel"),
                    handler: () => { }
                }
            ]

            this.showAlert("Remove Student(s)","Are you sure?",buttons);
         }
        //this.setState({modalshow:true})
    }

    hideAdminModal(userResponse=null){
        var me=this;
        var callBack = function(){
            me.setState({type:"",modalShow:false})
        }
        if(userResponse){
            this.loadJson(userResponse,callBack);
        }else{
            callBack.apply(this);
        }
       
        //console.log("modal close : ",userResponse);
        
    }

    filterDuplicates(userList, forceFilter=false){
        let me = this;
                    
        if(!this.duplicateEntryAllowed || forceFilter){
            let uniqUserList = [];

            if(userList && userList.length > 0){
                let tempLoginSet = new Set();
                let uniqDefiners = ["userName","levelSecMap>levelName","levelSecMap>sectionName"];

                for(let i=0; i< userList.length; i++){
                    let tmpUniqKey = "";
                    try{
                        for(let k=0; k<uniqDefiners.length; k++){
                            if(uniqDefiners[k]){
                                if(~uniqDefiners[k].indexOf(">")){
                                    let tmpDefinerArr = uniqDefiners[k].split(">");
                                    if(tmpDefinerArr.length > 1){
                                     tmpUniqKey += (userList[i][tmpDefinerArr[0]] && userList[i][tmpDefinerArr[0]][tmpDefinerArr[1]]) ? userList[i][tmpDefinerArr[0]][tmpDefinerArr[1]] : "";     
                                 }else{
                                     tmpUniqKey += (userList[i][tmpDefinerArr[0]]) ? userList[i][tmpDefinerArr[0]] : "";     
                                 }
                             }else{
                                tmpUniqKey += (userList[i][uniqDefiners[k]]) ? userList[i][uniqDefiners[k]] : "";
                            }
                        }
                    }
                }catch(e){
                    console.error(e);
                }

                if(tmpUniqKey && tempLoginSet.has(tmpUniqKey.toLowerCase())){
                     let userObj = {
                        "loginId" : userList[i].loginId,
                        "userId" : userList[i].userId,
                        "userRefId" : userList[i].userRefId
                    };
                                          
                    userList[i].duplicate = true;    
                    me.duplicateLoginIds.add(userObj);                    
                }else{
                    userList[i].duplicate = false;
                    uniqUserList.push(userList[i]);
                    tempLoginSet.add(tmpUniqKey.toLowerCase());
                }
            }

            if(me.duplicateLoginIds.size > 0){
                me.deleteDuplicateLogins();
            }

            return (uniqUserList && uniqUserList.length > 0 && !this.duplicateEntryAllowed) ? uniqUserList : userList;
        }
        }
        return userList;
    }

    deleteDuplicateLogins(){
        let me=this;
        if(!this.duplicateEntryAllowed &&  this.duplicateLoginIds.size > 0){
            console.warn("IRREVERSIBLE ACTION: DELETING the Duplicate Logins ::", this.duplicateLoginIds);

            if(this.duplicateLoginIdAction === "force_delete"){
                let failure = (err) => {
                    console.error(err);
                }

                let success = (resp) => {
                    console.warn("Success :", resp);
                }
                
                let postData = {
                   "userList": me.duplicateLoginIds,
                   "userStatus": [me.tableStatus]
                }

                new CoreAjax(this.getUrlFor("DELETE_ACCOUNTS"),postData).post(success, failure);
            }else{
                console.warn("NOT DELETING THE ACCOUNTS  Since the chosen action is not 'force_delete' ");
            }
        }
    }

    loadJson(response = null,callBack){
        //alert("loadCurrentImage....");
        var me = this;
        let selfLoaded = false;
        if(response!==null){
            selfLoaded = true;
        }
        this.userList=[];
        me.setState({dataLoaded:false}); 
        
        var success = function(response){
            if(response!==null){
                //console.log("Pend response  ",response);
                if(response && response.userList){
                    let tableData = me.renderJsonData(me.filterDuplicates(response.userList));
                    me.setState({tableData:tableData, dataLoaded:true,nouseravailable:false}); 
                }else if(response && response.status==="no_users_available"){
                    me.setState({nouseravailable:true}); 
                }

                if(typeof callBack === "function"){
                    callBack.apply(this);
                }

                let checked = $("#checkAll").is(':checked');
                if(!(checked)){
                    $(".singleCheck input:checkbox").each(function(){
                        $(this).prop("checked",false);
                        });
                }

                if(response && response.userList){
                    me.refreshUI();
                }

                
            }
        } 

        var failure = function(err){

        }

        if(!selfLoaded){
            new HmAjax(this.getUrlFor("CONTEST_GET_PEND_REG").replace("{#contestId}",this.getSelectedContestGroup())).get(success, failure);
        }else{
            success.apply(this,[response]);
        }
    }

    renderJsonData(userList){
        let me = this;
        let tableData = [];
        
        if(me.duplicateLoginIdAction === "highlight"){
            userList = me.filterDuplicates(userList, true);
        }

        userList.map((userData,index)=>{

            tableData[index]={
            }
            tableData[index]["Student Name"]=userData["userName"];
            tableData[index]["User ID"]=userData["loginId"];
           
            tableData[index]["Level"]=userData["levelSecMap"]["levelName"];
            tableData[index]["Class"]=userData["levelSecMap"]["sectionName"];
            tableData[index]["Email ID"]=userData["email"];
            tableData[index]["Prep Course"]=userData["prepPurchaseStatus"];       

            tableData[index]["gender"]=userData["gender"];
            tableData[index]["userId"]=userData["userId"];
            tableData[index]["userRefId"]=userData["userRefId"];

            tableData[index]["checked"] = false;
            tableData[index]["duplicate"]= (me.duplicateLoginIdAction === "highlight" && userData["duplicate"]) ? userData["duplicate"] : false; 
           
            // tableData[index].hiddenData=[]
            // tableData[index].hiddenData.push({
            //     "loginId":userData["loginId"],
            //     "userId":userData["userId"],
            //     "userRefId":userData["userRefId"]
            // })

        })
        return tableData;
    }

    toggle() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    optionClick(value,e){
        //console.log("option clicked ",value);
        this.setState(prevState => ({
            tick:!prevState.tick
        }))
       
    }

    createSelectItems() {
       
        let tick = this.state.tick ? "done":"done";
        let tickCls = tick == "done" ? "success" : "";
            if(this.state.data!=null){
                return (<DropdownItem>
                {
                    this.state.data.map((col,index)=>{

                    return(
                        <div className="dd-option" key={index} onClick={this.optionClick.bind(this,col)}>
                        <i className={"material-icons " +tickCls}>{tick}</i>
                        <option value={col} onClick={this.dropdownCheckAllfn.bind(this,col)}>  {col} </option>
                        </div>
                        )
                    })
                }
                </DropdownItem>
                )
                }
            }  

            onDropdownSelected(e) {
                //console.log("THE VAL", e.target.value);
        //here you will see the current selected value of the select input
    }

    selectAllData(type){
        let me=this;
        switch(type){
            case "add":
            {
                me.userList=[];
                let tableData = me.state.tableData || [];
                tableData.map((data,index)=>{
                    me.addUserData(data);
                });
                break;
            }
            case "remove":
            {
                me.userList=[];
                //console.log("userList ",me.userList);
                break;
            }
            default:
            //console.log("empty")
        }
    }

    checkAllfn() {
        let me = this;
        
        $("#checkAll").change(function(){
            let checked = $(this).is(':checked');
            if(checked){
              $(".singleCheck input:checkbox").each(function(){
                 $(this).prop("checked",true);
              });
              me.selectAllData("add");
            }else{
              $(".singleCheck input:checkbox").each(function(){
                $(this).prop("checked",false);
              });
              me.selectAllData("remove");
              me.setState({allowtoShow:false});
            }

            if(ReactDOM.findDOMNode(me.refs.AdminTable)){
                if(typeof me.refs.AdminTable.checkAllFn === "function"){
                  me.refs.AdminTable.checkAllFn(checked);
                }				
              }
            $('#checkAll').off('change');
            
        });

        
    }
    dropdownCheckAllfn(val,e) {
        let selectedOpt = val;
        let me = this;
        if(selectedOpt == "All"){
            // $(".singleCheck input:checkbox").each(function(){
            //     $(this).prop("checked",true);
            // });
            $("#checkAll").prop("checked",true);
            me.selectAllData("add");
            if(ReactDOM.findDOMNode(me.refs.AdminTable)){
                if(typeof me.refs.AdminTable.checkAllFn === "function"){
                  me.refs.AdminTable.checkAllFn(true);
                }				
            }
        }else if(selectedOpt == "None"){
           
            // $(".singleCheck input:checkbox").each(function(){
            // $(this).prop("checked",false);
            // });
            $("#checkAll").prop("checked",false);
            me.selectAllData("remove");
            me.setState({allowtoShow:false});
            if(ReactDOM.findDOMNode(me.refs.AdminTable)){
                if(typeof me.refs.AdminTable.checkAllFn === "function"){
                  me.refs.AdminTable.checkAllFn(false);
                }				
            }
        }
       // $('#checkAll').off('change');
    }
    customDropdown() {
        return (
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
            <DropdownToggle>
            <FormGroup check>                            
            <Input type="checkbox" id="checkAll" onChange={this.checkAllfn}/><Label check><i className="material-icons">arrow_drop_down</i>
            </Label>
            </FormGroup>
            </DropdownToggle>
            <DropdownMenu>
            {this.createSelectItems()}
            </DropdownMenu>
            </Dropdown>  
            );       
    }

    editCheckBox(userData){
        if(this.state.RegistrationOpen){
            this.addUserData(userData);
        }
    }

    getuserList(){
        //console.log("getuserList ",this.userList.length)
        let userListLength = (this.userList) ? (this.userList.length) : 0;
        return userListLength;
    }

 showLoader(){
     return(
        <div className="text-center">
        <Loader 
        type="Oval"
        color="#00BFFF"
        height="100"	
        width="100"
        />
        </div>
    )
 }
  render(){
      let me=this;
      let RegistrationOpen = this.state.RegistrationOpen;
      let RegClass = "";
      if(!RegistrationOpen){
        RegClass = "disabled";
      }
    const settings = {
        userFeature:{
            "0":{
                "name":"checkbox",
                "order":"0",
                "clickEvent":this.editCheckBox,
                "active":RegistrationOpen
            },
            "1":{
                "name":"edit",
                "order":"7",
                "clickEvent":this.editStudent,
                "active":RegistrationOpen
            }
        },
        userFeatureOrder:[0,7],
        filters : ["Prep Course","Level","Class"],
        data:this.state.tableData,
        contestType:this.getSelectedContestGroup(),
        pagination:true,
        pagePerPage:10,
        toolTipArr:[1,5]
        };

       if(this.state.nouseravailable){
            //console.log("pending ",this.state.nouseravailable);
            return (
                <div className="RegTable pendingReg">    
                    <div className="RegFunc nouseravail">  
                    <div>
                        {this.rb("contest.all_pending_students")}
                    </div><br/>
                    <div data-ga="Empty pending-Add student" className={"personAdd "+RegClass} onClick={this.createStudent}> {this.rb("add_student")}
                    <i className="material-icons">person_add</i>
                    </div>

                    <AdminModal getCount={this.getCount} status={this.tableStatus} modalShow={this.state.modalShow} type={this.state.type} dataObj={this.state.schoolsDataList} callBackParent={this.hideAdminModal} userData={this.userData}></AdminModal>
                    
                    </div>
                    </div>
            )    
        }else if(this.state.dataLoaded && this.state.tableData){ 
            return(
                <div className="RegTable pendingReg">               
                <div className="RegFunc">
                <div className="checkSelect main-check">
                {this.customDropdown()}
                </div>
                {
                    (()=>{
                        let allowtoShow = (this.state.allowtoShow == true) ? "active":"disabled";
                        
                        //if(this.state.allowtoShow){
                            return(
                                <div className={"registerSelect "+allowtoShow+" "+RegClass} data-ga="Confirm registration button" onClick={this.registerFn}>
                <i className="material-icons">description</i>{this.rb("contest.student.register")}
                </div>
                            )
                        //}
                    })()
                }

                {
                    (()=>{
                        let allowtoShow = (this.state.allowtoShow == true) ? "active":"disabled";

                        //if(this.state.allowtoShow){
                            return(
                <div className={"removeSelect "+allowtoShow+" "+RegClass} data-ga="Remove student button" onClick={this.removeStudent}>
                <i className="material-icons">delete</i>{this.rb("contest.student.remove")}
                </div>
                )
                        //}
                    })()
                }

                {/* <div className="checkSelect">
                <SearchLayout></SearchLayout>
            </div> */}

            <div className={"personAdd"+" "+RegClass} data-ga="Add student button" onClick={this.createStudent}> {this.rb("add_student")}
            <i className="material-icons">person_add</i>
            </div>
          
                
            </div>

         

            {(()=>{

                if(this.state.tableData && (this.state.tableData.length)>0){
                    return(
                        <AdminLayout ref={"AdminTable"} getuserList={this.getuserList} getCount={this.getCount} data={settings}/>
                        )
                }
            })()}

            {(()=>{

            if(this.state.tableData){
                return(
                    <AdminModal getCount={this.getCount} status={this.tableStatus} modalShow={this.state.modalShow} type={this.state.type} dataObj={this.state.schoolsDataList} callBackParent={this.hideAdminModal} userData={this.userData}></AdminModal>
                    )
            }
            })()}


            </div>
            )
        }else{
            return <div>{me.showLoader()}</div>      
        } 
    }
}


// WEBPACK FOOTER //
// ./src/views/registration/PendingRegTable.js